/**
 * Renders a timestamp as a short local day ("Sep 11"). A date-only value ("2026-09-11") keeps its
 * calendar day. '' for anything that is not a date.
 */
const formatShortDate = (value) => {
  const ms = Date.parse(value || '');
  const timeZone = /^\d{4}-\d{2}-\d{2}$/.test(value || '') ? 'UTC' : undefined;
  return Number.isFinite(ms) ? new Date(ms).toLocaleDateString(undefined, { month: 'short', day: 'numeric', timeZone }) : '';
};

export default formatShortDate;
